import { Thumbnail } from '../../../Thumbnail/Thumbnail';

import type { FC } from 'react';

import styles from './Profile.module.scss';

type Props = {
  profile: {
    images?: { main?: string | null };
    title?: string;
  };
  className?: string;
};

const Profile: FC<Props> = ({ profile, className }) => {
  return (
    <div className={className}>
      {profile.images && (
        <Thumbnail
          url={`${profile.images.main}?t[]=180q80`}
          alt={profile.title}
          isRound
        />
      )}
      <div className={styles.title}>{profile.title}</div>
    </div>
  );
};

export { Profile };
